import pattern from "../../assets/brand/pattern.png";

/**
 * The apps' RotatingLogoPattern: one large logo burst anchored off the
 * bottom-right corner, turning slowly anticlockwise (one turn / 20s). Same
 * size and offset as the app splash (350px, pushed 50px off-screen). Freezes
 * under prefers-reduced-motion via the global reduced-motion rule.
 */
export function RotatingPattern({ size = 350, offset = 50 }: { size?: number; offset?: number }) {
  return (
    <img
      src={pattern}
      alt=""
      aria-hidden
      className="rotating-pattern"
      style={{
        position: "fixed",
        right: -offset,
        bottom: -offset,
        width: size,
        height: size,
        pointerEvents: "none",
        userSelect: "none",
        zIndex: 0,
      }}
    />
  );
}
